import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import { gridsNames } from '../../../../enums/gridsNames';
import { FetchEntitiesFilters } from '../../../../enums/fetchEntitiesFilters';
import { ImportTypes, ImportAcceptFileTypes } from '../../../../enums/importTypes';
import RollsGrid from './RollsGrid/rollsGrid';
import { getEnumValue, enumTypes } from '../../../../utils/enumHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {
  getLocationAssetTypes,
  getLocationAssetTypesForPrintPdfLabels, isIncomingShipments, isOutgoingShipments,
  isOutgoingOrIncomingLocation, isShippingPreparation, isFreezerLocation,
} from '../../../../utils/locationHelper';
import CreateRoll from '../Dialogs/CreateRollDialog/createRollDialog';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import CommonDialogWrapper from '../../../Dialogs/CommonDialogWrapper/commonDialogWrapper';
import {dialogsNames} from '../../../../enums/dialogsNames';

require('./rollsView.scss');

export default class RollsView extends Component {

  constructor (props) {
    super(props);
    this.labels = createLabelHelper('mat.locationpage.view.assets.');
  }

  getDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getMoveAssetsDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')),
      preselectedAssets: sSelectedRowsData,
    };
  };

  getBringAssetsDialogConfig = () => {
    let {sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')),
    };
  };

  getImportConfig = () => {
    return {
      importTypes: [ImportTypes.IMPORT_ROLLS],
      acceptFileTypes: [ImportAcceptFileTypes.CSV],
      parentComponent: this.onRefreshAll,
      shouldIncludeLocation: false, //import is done from a location , the import file locationId column is optional.
      showPrintLabels: true,
    };
  };

  getPrintPdfLabelsDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ALL],
      preselectedAssets: this.props.sSelectedRowsData,
      entitiesTypes: getLocationAssetTypesForPrintPdfLabels(this.props.sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')),
    };
  };

  getAddToGroupDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      preselectedAssets: this.props.sSelectedRowsData,
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')),
    };
  };

  getEditLengthDialogConfig = () => {
    let payload = this.getDialogConfig();
    payload.editLengthOnly = true;
    return payload;
  };

  onRefreshAll = () => {
    this.props.actions?.reloadParentComponent();
  };

  getHeaderItems() {
    let { actions, sHasRows, sSelectedRowsData, sLocationDetails, loading } = this.props;

    let dialogConfig = this.getDialogConfig();
    let importConfig = this.getImportConfig();

    let items = {
      title: this.labels.get('title.rolls'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
          actionData: {gridName: gridsNames.LOCATION_ASSET_ROLLS}
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: this.onRefreshAll,
          tooltip: headerItemsLabels.REFRESH_ALL,
          disabled: loading,
        },
        ///EDIT LENGTH BUTTON (for Trial org only)
        ...(PermissionManager.editLengthInFreezerPermissions() && isFreezerLocation(sLocationDetails)
          ? [
              {
                id: 'editLength',
                label: headerItemsLabels.EDIT_LENGTH,
                icon: 'pl pl-edit-icon header-button',
                action: actions.headerActions.onMenuItemEditAssetAttributesClick,
                actionData: this.getEditLengthDialogConfig(),
                disabled: loading,
              },
            ]
          : []),
        ...(isShippingPreparation(sLocationDetails)
          ? [
              {
                id: 'importRolls',
                label: headerItemsLabels.IMPORT_ROLLS,
                icon: 'pl pl-bring-assets',
                action: actions.headerActions.importItems,
                actionData: importConfig,
              },
          ]
          : []),
        ...(!isOutgoingShipments(sLocationDetails)
          ? [
              {
                id: 'moveTo',
                label: headerItemsLabels.MOVE_TO,
                icon: 'pl pl-move-assets',
                counter: sSelectedRowsData.size,
                action: actions.headerActions.onMenuItemMoveToClick,
                actionData: this.getMoveAssetsDialogConfig(),
                disabled: loading,
              },
          ]
          : []),
        ...(this.isBringHereEnabled()
          ? [
              {
                id: 'bringHere',
                label: headerItemsLabels.BRING_HERE,
                icon: 'pl pl-bring-assets',
                action: actions.headerActions.onMenuItemBringHereClick,
                actionData: this.getBringAssetsDialogConfig(),
                disabled: loading,
              },
          ]
          : []),
      ],

      kebab: isOutgoingShipments(sLocationDetails) || isIncomingShipments(sLocationDetails) ? null :
        {
          disabled: loading || isOutgoingOrIncomingLocation(sLocationDetails),
          menuItems: isShippingPreparation(sLocationDetails ) ?
          [
            {
              id: 'addToShipment',
              label: headerItemsLabels.ADD_TO_SHIPMENT,
              // disabled: !sHasRows,
              action: actions.headerActions.onAddToShipmentDialogClick,
              actionData: dialogConfig,
            },
          ]
          :
          [
          ...(PermissionManager.hasUpdateShelfLifePermissions()
            ? [
                {
                  id: 'updateShelfLife',
                  label: headerItemsLabels.UPDATE_SELF_LIFE,
                  disabled: !sHasRows,
                  action: actions.headerActions.onUpdateShelfLifeClick,
                  actionData: dialogConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasCreateAssetsPermissions()
            ? [
                {
                  id: 'createRoll',
                  label: headerItemsLabels.CREATE_ROLL,
                  action: actions.headerActions.onShowCreateRollDialog,
                  actionData: {
                    activeDialog: dialogsNames.CREATE_ROLL_DIALOG,
                  }
                },
              ]
            : []),
            {
              id: 'assignTag',
              label: headerItemsLabels.ASSIGN_TAG,
              action: actions.headerActions.onShowAssignRemoveAssetsTagsDialog,
              actionData: {
                activeDialog: dialogsNames.ASSIGN_REMOVE_ASSETS_TAGS_DIALOG,
                dialogData: {
                  mode : 'ASSIGN'
                }
              }
            },
            {
              id: 'removeTag',
              label: headerItemsLabels.REMOVE_TAG,
              action: actions.headerActions.onShowAssignRemoveAssetsTagsDialog,
              actionData: {
                activeDialog: dialogsNames.ASSIGN_REMOVE_ASSETS_TAGS_DIALOG,
                dialogData: {
                  mode : 'REMOVE'
                }
              }
            },


          ...(PermissionManager.hasArchiveAssetsPermissions()
            ? [
                {
                  id: 'archive',
                  label: headerItemsLabels.ARCHIVE,
                  action: actions.headerActions.onMenuItemArchiveClick,
                  actionData: dialogConfig,
                  disabled: !sHasRows,
                },
              ]
            : []),

          {
            id: 'export',
            label: headerItemsLabels.EXPORT_ROLLS_LIST,
            action: actions.headerActions.export,
            actionData: { gridName: gridsNames.LOCATION_ASSET_ROLLS },
            disabled: !sHasRows,
          },

          {
            id: 'exportRollsUsage',
            label: headerItemsLabels.EXPORT_ROLLS_USAGE,
            action: actions.headerActions.exportUsage,
            actionData: { gridName: gridsNames.LOCATION_ASSET_ROLLS },
          },

          ...(PermissionManager.hasGroupAssetPermissions() &&
          PermissionManager.getOrgPreferences().groupsEnabled
            ? [
                {
                  id: 'addToGroup',
                  label: headerItemsLabels.ADD_TO_GROUP,
                  disabled: !sHasRows,
                  action: actions.headerActions.onAddToGroupDialogClick,
                  actionData: this.getAddToGroupDialogConfig(),
                },
              ]
            : []),

          ...(PermissionManager.hasEditAttributesPermissions()
            ? [
                {
                  id: 'editAttributes',
                  label: headerItemsLabels.EDIT_ATTRIBUTES,
                  disabled: !sHasRows,
                  action: actions.headerActions.onMenuItemEditAssetAttributesClick,
                  actionData: dialogConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importRolls',
                  label: headerItemsLabels.IMPORT_ROLLS,
                  action: actions.headerActions.importItems,
                  actionData: importConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importRollsViaBarcode',
                  label: headerItemsLabels.IMPORT_ROLLS_VIA_BARCODE,
                  action: actions.headerActions.onImportAssetsViaBarcodeClick,
                  actionData: { importType: ImportTypes.IMPORT_ROLLS },
                },
              ]
            : []),

          ...(PermissionManager.hasEditAttributesPermissions()
            ? [
                {
                  id: 'importAttributesUpdate',
                  label: headerItemsLabels.IMPORT_ATTRIBUTES_UPDATE,
                  action: actions.headerActions.onMenuItemImportAttributesUpdateClick,
                  actionData: { importType: getEnumValue(enumTypes.IMPORT_TYPE)('UPDATE_ROLL') },
                },
              ]
            : []),

          {
            id: 'printRfidTags',
            label: headerItemsLabels.PRINT_RFID_TAGS,
            action: actions.headerActions.onMenuItemPrintRfidTagsClick,
            actionData: dialogConfig,
            disabled: !sHasRows,
          },

          ...(PermissionManager.getOrgPreferences().printZplGenericAssetEnabled
            ? [
                {
                  id: 'printEmptyTags',
                  label: headerItemsLabels.PRINT_EMPTY_TAGS,
                  action: actions.headerActions.onMenuItemPrintEmptyRfidTagsClick,
                },
              ]
            : []),

          {
            id: 'printPdfLabels',
            label: headerItemsLabels.PRINT_LABEL,
            action: actions.headerActions.onMenuItemPrintLabelClick,
            actionData: this.getPrintPdfLabelsDialogConfig(),
          },
        ],
      },
    };

    return items;
  }

  isBringHereEnabled = () => {
    if(isOutgoingShipments(this.props.sLocationDetails) && PermissionManager.getOrgPreferences().preventMoveAssetsToOutgoingShipment) {
      return false;
    }

    return !isIncomingShipments(this.props.sLocationDetails)
  }

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="rolls-view">
        <Header {...headerItems} />

        <RollsGrid
          actions={{...this.props.actions.assetsRollsGridActions, ...this.props.actions.fetchEntitiesActions}}
          locationDetails={this.props.sLocationDetails}
          cellAction={this.props.actions.getAssetRelatedAssets}
        />

        <CommonDialogWrapper dialogComponent={CreateRoll}
                             dialogName={dialogsNames.CREATE_ROLL_DIALOG}
                             actions={this.props.actions.createRollActions}
                             reloadParentComponent={this.onRefreshAll}
        />
      </div>
    );
  }
}
//{/*{...this.props.actions.createRollActions}*/}
RollsView.propTypes = {
  actions: PropTypes.object.isRequired,
  sHasRows: PropTypes.bool.isRequired,
  sSelectedRowsData: PropTypes.object.isRequired,
  sLocationDetails: PropTypes.object.isRequired,
};
